// @flow

/**
 * TODO: replace {var} by :var
 */
const APIEndpoints = {
  API_CONSUMERS: '/restaurants-groups/:restaurantsGroupId/api-consumers',

  API_CONSUMER: '/api-consumers/:apiConsumerId',

  PRO_OAUTH_TOKEN: '/pro/oauth/token',

  OAUTH_AUTHORIZE_APP: '/oauth/authorize',

  RESTAURANTS: '/restaurants',

  RESTAURANT: '/restaurants/:restaurantId',

  STATISTICS: '/restaurant/{restaurantId}/stats',

  PAYINS: '/restaurant/{restaurantId}/payin',

  PAYOUTS: '/restaurant/{restaurantId}/payout',

  RESTAURANT_MENU: '/restaurants/{restaurantId}/menu',

  RESTAURANT_MENU_PRODUCTS: '/restaurants/{restaurantId}/menu/products',

  RESTAURANT_MENU_PRODUCT: '/restaurants/{restaurantId}/menu/products/{productId}',

  RESTAURANT_MENU_PRODUCT_IMAGE: '/restaurants/{restaurantId}/menu/products/{productId}/image',

  RESTAURANT_MENU_MENUS: '/restaurants/{restaurantId}/menu/menus',

  RESTAURANT_MENU_MENU: '/restaurants/{restaurantId}/menu/menus/{menuId}',

  RESTAURANT_MENU_MENU_IMAGE: '/restaurants/{restaurantId}/menu/menus/{menuId}/image',

  RESTAURANT_MENU_MENU_PART: '/restaurants/{restaurantId}/menu/menus/{menuId}/parts/{partId}',

  RESTAURANT_MENU_MENU_PART_CATEGORY: '/restaurants/{restaurantId}/menu/menus/{menuId}/parts/{partId}/categories/{categoryId}',

  RESTAURANT_MENU_MENU_PART_CATEGORY_IMAGE: '/restaurants/{restaurantId}/menu/menus/{menuId}/parts/{partId}/categories/{categoryId}/image',

  RESTAURANT_MENU_CATEGORIES: '/restaurants/{restaurantId}/menu/categories',

  RESTAURANT_MENU_CATEGORY: '/restaurants/{restaurantId}/menu/categories/{categoryId}',

  RESTAURANT_MENU_CATEGORY_IMAGE: '/restaurants/{restaurantId}/menu/categories/{categoryId}/image',

  RESTAURANT_MENU_UPSELLING_CATEGORIES: '/restaurants/{restaurantId}/menu/upselling-categories',

  RESTAURANT_MENU_UPSELLING_CATEGORY: '/restaurants/{restaurantId}/menu/upselling-categories/{upsellingCategoryId}',

  RESTAURANT_MENU_PRODUCT_OPTIONS: '/restaurants/{restaurantId}/menu/options',

  RESTAURANT_MENU_PRODUCT_OPTION: '/restaurants/{restaurantId}/menu/options/{productOptionId}',

  RESTAURANT_MENU_PRODUCT_OPTION_IMAGE: '/restaurants/{restaurantId}/menu/options/{productOptionId}/image',

  CART_MODIFIERS: '/restaurants/{restaurantId}/menu/cart-modifiers',

  CART_MODIFIER: '/restaurants/{restaurantId}/menu/cart-modifiers/{cartModifierId}',

  CART_MODIFIERS_PRIORITIES: '/restaurants/{restaurantId}/menu/cart-modifiers/priorities',

  //
  // Order
  //

  ORDERS: '/orders',

  ORDERS_PREVIEW: '/orders-previews',

  ORDERS_ON_GOING: '/orders/on-goings',

  ORDER: '/orders/{orderId}',

  ORDER_SETTINGS: '/restaurants/{restaurantId}/order-settings',

  CHECKS: '/checks',

  REVIEWS_SUMMARY: '/reviews',

  CLAIMS_DISCUSSIONS_SETTINGS: '/restaurants/{restaurantId}/claims-discussions-settings',

  PAYMENTS: '/payments',

  PAYMENT_PDF: '/payments/{paymentId}/pdf',

  //
  // Bookings
  //

  BOOKINGS: '/bookings',

  WAITING_BOOKINGS: '/bookings/waitings',

  UNSEEN_BOOKINGS: '/bookings/unseen',

  BOOKING: '/bookings/{bookingId}',

  UPDATED_BOOKINGS: '/bookings/updated',

  BOOKINGS_SLOTS: '/bookings/slots',

  BOOKINGS_SETTINGS: '/bookings/settings',

  BOOKINGS_SPECIFICS_SETTINGS: '/bookings/settings/specifics',

  BOOKINGS_CAPACITY_SPECIFICS: '/bookings/settings/capacity-specifics',

  BOOKINGS_CAPACITY_SPECIFIC: '/bookings/settings/capacity-specifics/{capacitySpecificId}',

  BOOKINGS_GUESTS_BOOKED: '/bookings/guests-booked',

  PDF_BOOKINGS_LIST_LINK: '/bookings/pdf-link',

  NOTIFICATIONS_SETTINGS_BOOKING: '/notifications/settings/features/4',

  //
  // News
  //

  NEWS_LIST: '/restaurants/{restaurantId}/news',

  NEWS: '/restaurants/{restaurantId}/news/{newsId}',

  DASHBOARD_INFO_RESTAURANT: '/dashboards/restaurants/{restaurantId}',

  //
  // Restaurants group
  //

  RESTAURANTS_GROUP: '/restaurants-groups/:restaurantsGroupId',

  RESTAURANTS_GROUPS: '/restaurants-groups',

  RESTAURANTS_GROUP_ROLES: '/restaurants-groups/:restaurantsGroupId/pro/roles',

  RESTAURANTS_GROUP_DOMAINS: '/restaurants-groups/:restaurantsGroupId/pro/domains',

  RESTAURANTS_GROUP_ORDER_STATISTICS: '/restaurants-groups/{restaurantsGroupId}/stats/order/general-stats',

  RESTAURANTS_GROUP_API_CONSUMERS: '/restaurants-groups/{restaurantsGroupId}/api-consumers',

  /**
   * Export
   */
  EXPORT: '/restaurants-groups/:restaurantsGroupId/export',

  //
  // Roles
  //

  PRO_ROLE: '/pro/roles/:roleId',

  PRO_ROLES: '/pro/roles',

  //
  // Pro account
  //
  LOGIN: '/pro/accounts/me/domains',

  PRO_FORGOT_PASSWORD: '/pro/password-recovery/recover',

  PRO_ME_ACCOUNT: '/pro/accounts/me',

  PRO_ME_ACCOUNT_DOMAINS: '/pro/accounts/me/domains',

  PRO_ACCOUNTS: '/pro/accounts',

  PRO_ACCOUNT: '/pro/accounts/:accountId',

  PRO_ACCOUNT_DOMAINS: '/pro/accounts/:accountId/domains',

  PRO_DOMAIN_ROLE: '/pro/domains/:domainId/roles',

  //
  // notifications
  //

  EMAIL: '/emails',

  SMS: '/sms',

  //
  // Users
  //

  USERS: '/users',

  USER: '/users/:userId',

  USER_ME: '/users/me',

  USER_CREDIT_CARDS: '/users/:userId/cards',

  ME_CREDIT_CARDS: '/users/me/cards',

  ME_CREDIT_CARD: '/users/me/cards/:creditCardId',

  ME_CREDIT_CARD_REGISTRATION: '/users/me/cards-registration',

  USER_CREDIT_CARD_REGISTRATION: '/users/:userId/cards-registration',

  USER_ADDRESSES: '/users/:userId/addresses',

  USER_ADDRESS: '/users/:userId/addresses/:addressId',

  CRM_ACCOUNT: '/crm/{restaurantId}/account',

  USER_RECOVER_PASSWORD: '/users/password-recovery/recover?email=:userEmail',

  USER_ACCOUNTS: '/users/:userId/accounts',

  //
  // Kiosk
  //
  KIOSK_SETTINGS: '/restaurants/:restaurantId/kiosk-settings',

  POST_CUSTOM_TEXTS_CONTAINERS: '/customs/texts-containers/',
  GET_CUSTOM_TEXTS_CONTAINERS: '/customs/texts-containers/:customTextsContainerId',
  PUT_CUSTOM_TEXTS_CONTAINERS: '/customs/texts-containers/:customTextsContainerId',
};

export default APIEndpoints;
